import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { useDeferredValue } from 'react';
import { CertificateAuthorities, certificateAuthorityQueryKeys } from '#api';

const makeCertificateAuthoritiesQueryOptions = (cursor?: string, pageSize?: number) =>
  queryOptions({
    queryKey: certificateAuthorityQueryKeys.list(cursor, pageSize),
    queryFn: ({ signal }) => CertificateAuthorities.getCertificateAuthorities({ cursor, pageSize, init: { signal } }),
  });

/**
 * Fetch a paginated list of certificate authorities.
 */
export function useSuspenseCertificateAuthoritiesQuery(cursor?: string, pageSize?: number) {
  const deferredCursor = useDeferredValue(cursor);
  const deferredPageSize = useDeferredValue(pageSize);

  const caQuery = useSuspenseQuery(makeCertificateAuthoritiesQueryOptions(deferredCursor, deferredPageSize));

  return {
    data: caQuery.data,
    isFetching: deferredCursor !== cursor || deferredPageSize !== pageSize || caQuery.isFetching,
  };
}
